import { Analysis } from 'common-spectrum';
import max from 'ml-array-max';
import mean from 'ml-array-mean';
import min from 'ml-array-min';
import sd from 'ml-array-standard-deviation';
import { pelletHardnessParseHitec } from 'physical-chemistry-parser';

export function fromHitec(dt0, res) {
  let analysis = new Analysis();
  const parsed = pelletHardnessParseHitec(dt0, res);
  let meta = {};
  for (let key in parsed.meta) {
    meta = { ...meta, ...parsed.meta[key] };
  }

  let iph = parsed.variables.y.data;
  let top10 = iph.sort((a, b) => b - a).slice(0, iph.length / 10);
  const cheminfo = {
    meta: {
      average50: {
        value: mean(iph),
        units: 'cN',
      },
      sd: {
        value: sd(iph),
        units: 'cN',
      },
      min: {
        value: min(iph),
        units: 'cN',
      },
      max: {
        value: max(iph),
        units: 'cN',
      },
      averageHardest10: {
        value: mean(top10),
        units: 'cN',
      },
      method: meta.QualityName,
    },
  };

  meta.cheminfo = cheminfo;


  analysis.pushSpectrum(
    {
      x: parsed.variables.x,
      y: parsed.variables.y,
    },
    {
      dataType: 'Individual pellet hardness',
      title: meta.Meta,
      meta,
    },
  );

  return analysis;
}
